// Bali Lux Vacances - Luxury Travel Mock Data

export const destinations = [
  {
    id: 'bali',
    name: 'Bali',
    tagline: 'Island of the Gods',
    description: 'Experience the enchanting blend of ancient temples, lush rice terraces, and world-class luxury resorts. From private cliff-top villas in Uluwatu to serene wellness retreats in Ubud, Bali offers unparalleled luxury experiences.',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800',
    heroImage: 'https://images.unsplash.com/photo-1760943006664-3278c14068d6?w=1600',
    bestTime: 'April - October',
    highlights: ['Ubud Rice Terraces', 'Uluwatu Temple', 'Nusa Dua Beach', 'Sidemen Valley'],
    subDestinations: [
      { name: 'Ubud', description: 'Cultural heart with rice terraces, art galleries, and world-renowned wellness retreats' },
      { name: 'Uluwatu', description: 'Dramatic cliffs, world-renowned surf breaks, and exclusive cliff-top resorts' },
      { name: 'Nusa Dua', description: 'Pristine beaches and 5-star resort enclave with championship golf courses' },
      { name: 'Sidemen', description: 'Untouched beauty, traditional Balinese life, and boutique eco-luxury retreats' },
      { name: 'Amed', description: 'Serene coastal village with exceptional diving and authentic charm' },
      { name: 'North Bali', description: 'Volcanic landscapes, hidden waterfalls, and secluded luxury hideaways' }
    ]
  },
  {
    id: 'lombok',
    name: 'Lombok',
    tagline: 'The Unspoiled Paradise',
    description: 'Discover pristine beaches, majestic Mount Rinjani, and authentic Sasak culture. Lombok offers a more serene alternative to Bali with equally stunning landscapes and exclusive boutique resorts.',
    image: 'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=800',
    heroImage: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1600',
    bestTime: 'May - September',
    highlights: ['Mount Rinjani', 'Senggigi Beach', 'Kuta Lombok', 'Sasak Villages']
  },
  {
    id: 'gili-islands',
    name: 'Gili Islands',
    tagline: 'Tropical Island Trio',
    description: 'Three idyllic islands offering crystal-clear waters, vibrant coral reefs, and no motorized vehicles. Experience the ultimate island escape with luxury beachfront villas and world-class diving.',
    image: 'https://images.unsplash.com/photo-1637576308588-6647bf80944d?w=800',
    heroImage: 'https://images.unsplash.com/photo-1738762932370-468a90e0ff68?w=1600',
    bestTime: 'May - September',
    highlights: ['Gili Trawangan', 'Gili Meno', 'Gili Air', 'Turtle Snorkeling']
  },
  {
    id: 'sumba',
    name: 'Sumba',
    tagline: 'The Hidden Gem',
    description: 'An untouched island of rolling savannas, ancient traditions, and the world\'s most exclusive luxury retreats. Sumba is where discerning travelers find true exclusivity.',
    image: 'https://images.unsplash.com/photo-1729708790933-181ab8d90e0c?w=800',
    heroImage: 'https://images.unsplash.com/photo-1590490359854-dfba19688d70?w=1600',
    bestTime: 'April - November',
    highlights: ['Nihiwatu Beach', 'Traditional Villages', 'Pasola Festival', 'Weekuri Lagoon']
  },
  {
    id: 'raja-ampat',
    name: 'Raja Ampat',
    tagline: 'The Last Paradise',
    description: 'The world\'s most biodiverse marine destination with over 1,500 fish species and 600 coral species. Experience luxury liveaboards and exclusive eco-resorts in this pristine archipelago.',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    heroImage: 'https://images.unsplash.com/photo-1682687982501-1e58ab814714?w=1600',
    bestTime: 'October - April',
    highlights: ['Wayag Islands', 'Misool', 'Manta Ray Diving', 'Bioluminescent Bays']
  },
  {
    id: 'java',
    name: 'Java',
    tagline: 'Ancient Temples & Culture',
    description: 'Home to UNESCO World Heritage temples, volcanic landscapes, and rich Javanese heritage. Explore Borobudur at sunrise and discover palatial luxury in Yogyakarta.',
    image: 'https://images.unsplash.com/photo-1596402184320-417e7178b2cd?w=800',
    heroImage: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=1600',
    bestTime: 'May - September',
    highlights: ['Borobudur Temple', 'Prambanan', 'Mount Bromo', 'Yogyakarta']
  },
  {
    id: 'borneo',
    name: 'Borneo',
    tagline: 'The Wild Heart',
    description: 'Ancient rainforests, endangered orangutans, and the mighty Mahakam River. Experience luxury jungle lodges and exclusive wildlife encounters in one of Earth\'s oldest ecosystems.',
    image: 'https://images.unsplash.com/photo-1589446918494-cc44735e6f20?w=800',
    heroImage: 'https://images.unsplash.com/photo-1679327377991-ec278e4cdb3e?w=1600',
    bestTime: 'March - October',
    highlights: ['Orangutan Sanctuaries', 'Derawan Islands', 'Mahakam River', 'Dayak Culture']
  },
  {
    id: 'sulawesi',
    name: 'Sulawesi',
    tagline: 'The Unique Island',
    description: 'Distinctive culture of Toraja, world-class diving at Bunaken, and unique wildlife. Sulawesi offers extraordinary cultural experiences and pristine marine adventures.',
    image: 'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=800',
    heroImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1600',
    bestTime: 'April - December',
    highlights: ['Tana Toraja', 'Bunaken Marine Park', 'Togean Islands', 'Makassar']
  },
  {
    id: 'komodo-flores',
    name: 'Komodo & Flores',
    tagline: 'Dragons & Pink Beaches',
    description: 'Home to the legendary Komodo dragons, stunning pink beaches, and the spectacular Kelimutu crater lakes. Experience luxury yacht expeditions through this remarkable region.',
    image: 'https://images.unsplash.com/photo-1660280274563-767dd6b56374?w=800',
    heroImage: 'https://images.unsplash.com/photo-1704948211410-007f7d5f4355?w=1600',
    bestTime: 'April - December',
    highlights: ['Komodo National Park', 'Pink Beach', 'Kelimutu Lakes', 'Labuan Bajo']
  }
];

export const luxuryHotels = [
  {
    id: 1,
    name: 'Aman Villas at Nusa Dua',
    destination: 'Bali',
    category: '5-Star Resort',
    image: 'https://images.unsplash.com/photo-1590490359854-dfba19688d70?w=800',
    description: 'Exclusive beachfront villas with private pools, butler service, and world-class spa.',
    priceRange: '$$$$$'
  },
  {
    id: 2,
    name: 'Four Seasons Resort Bali',
    destination: 'Bali',
    category: 'Luxury Resort',
    image: 'https://images.unsplash.com/photo-1633605015660-b0f2dbad3bf2?w=800',
    description: 'Iconic resort nestled in the Sayan Valley with stunning rice terrace views.',
    priceRange: '$$$$$'
  },
  {
    id: 3,
    name: 'Nihi Sumba',
    destination: 'Sumba',
    category: 'Eco-Luxury',
    image: 'https://images.unsplash.com/photo-1729708790933-181ab8d90e0c?w=800',
    description: 'World\'s best hotel offering unparalleled exclusivity, surf, and cultural immersion.',
    priceRange: '$$$$$'
  },
  {
    id: 4,
    name: 'Misool Eco Resort',
    destination: 'Raja Ampat',
    category: 'Eco-Luxury',
    image: 'https://images.unsplash.com/photo-1637576308588-6647bf80944d?w=800',
    description: 'Overwater bungalows in the heart of the world\'s richest marine biodiversity.',
    priceRange: '$$$$'
  },
  {
    id: 5,
    name: 'Amanjiwo',
    destination: 'Java',
    category: '5-Star Resort',
    image: 'https://images.pexels.com/photos/2506990/pexels-photo-2506990.jpeg?w=800',
    description: 'Luxurious retreat overlooking the magnificent Borobudur Temple.',
    priceRange: '$$$$$'
  }
];

export const experiences = [
  {
    id: 'private-tours',
    title: 'Private Guided Tours',
    description: 'Exclusive access to hidden temples, local artisans, and cultural experiences with expert guides.',
    image: 'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=800',
    icon: 'Compass'
  },
  {
    id: 'cultural-immersions',
    title: 'Cultural Immersions',
    description: 'Authentic encounters with Balinese priests, Sasak weavers, and Torajan ceremonies.',
    image: 'https://images.unsplash.com/photo-1609130787305-826ad0e60af7?w=800',
    icon: 'Globe'
  },
  {
    id: 'helicopter-tours',
    title: 'Helicopter Tours',
    description: 'Soar above volcanic peaks, rice terraces, and pristine coastlines in ultimate luxury.',
    image: 'https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?w=800',
    icon: 'Plane'
  },
  {
    id: 'diving-snorkeling',
    title: 'Diving & Snorkeling',
    description: 'Discover world-class dive sites in Raja Ampat, Komodo, and the Gili Islands.',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    icon: 'Waves'
  },
  {
    id: 'spa-wellness',
    title: 'Spa & Wellness',
    description: 'Rejuvenate with traditional Balinese treatments and holistic wellness programs.',
    image: 'https://images.unsplash.com/photo-1719858511928-94db73c8de67?w=800',
    icon: 'Sparkles'
  },
  {
    id: 'culinary-journeys',
    title: 'Culinary Journeys',
    description: 'Private cooking classes, market tours, and exclusive fine dining experiences.',
    image: 'https://images.unsplash.com/photo-1752888016122-cc0059408ce5?w=800',
    icon: 'UtensilsCrossed'
  }
];

export const yachtServices = [
  {
    id: 'yacht-charter',
    title: 'Private Yacht Charters',
    description: 'Explore Indonesia\'s 17,000 islands aboard a luxury private yacht with full crew.',
    image: 'https://images.unsplash.com/photo-1600812703042-38e573598898?w=800',
    features: ['Full Crew', 'Gourmet Chef', 'Water Sports Equipment', 'Island Hopping']
  },
  {
    id: 'liveaboard',
    title: 'Luxury Liveaboards',
    description: 'Premium diving expeditions to Raja Ampat, Komodo, and Banda Sea.',
    image: 'https://images.unsplash.com/photo-1598448056086-307e98ef5c4a?w=800',
    features: ['Expert Dive Masters', 'Nitrox Available', 'Luxury Cabins', 'All Meals Included']
  },
  {
    id: 'sunset-cruise',
    title: 'Sunset Cruises',
    description: 'Romantic sunset sails with champagne and gourmet canapés.',
    image: 'https://images.unsplash.com/photo-1446822775955-c34f483b410b?w=800',
    features: ['Premium Champagne', 'Private Setting', 'Canapés', 'Photography']
  }
];

export const transportServices = [
  {
    id: 'luxury-car',
    title: 'Chauffeured Luxury Cars',
    description: 'Premium Mercedes and BMW fleet with professional bilingual drivers.',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800',
    icon: 'Car'
  },
  {
    id: 'private-driver',
    title: 'Private Drivers',
    description: 'Experienced local drivers for customized exploration at your own pace.',
    image: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800',
    icon: 'User'
  },
  {
    id: 'helicopter',
    title: 'Helicopter Transfers',
    description: 'Swift and scenic transfers between destinations.',
    image: 'https://images.unsplash.com/photo-1661954864180-e61dea14208a?w=800',
    icon: 'Plane'
  }
];

export const tailorMadeCategories = [
  {
    id: 'honeymoon',
    title: 'Honeymoons',
    description: 'Romantic escapes crafted for unforgettable beginnings.',
    image: 'https://images.unsplash.com/photo-1767050163046-b3ab180be169?w=800',
    icon: 'Heart'
  },
  {
    id: 'family',
    title: 'Family Luxury Travel',
    description: 'Multi-generational adventures with activities for all ages.',
    image: 'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?w=800',
    icon: 'Users'
  },
  {
    id: 'celebration',
    title: 'Celebration Trips',
    description: 'Milestone birthdays, anniversaries, and special occasions.',
    image: 'https://images.unsplash.com/photo-1446822775955-c34f483b410b?w=800',
    icon: 'PartyPopper'
  },
  {
    id: 'private',
    title: 'Ultra-Private Experiences',
    description: 'Maximum privacy and exclusivity for discerning travelers.',
    image: 'https://images.unsplash.com/photo-1760943006664-3278c14068d6?w=800',
    icon: 'Lock'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sophie & Pierre Laurent',
    location: 'Paris, France',
    quote: 'Our honeymoon in Bali exceeded every expectation. The attention to detail and exclusive experiences made it truly magical.',
    trip: 'Honeymoon, Bali & Lombok',
    rating: 5
  },
  {
    id: 2,
    name: 'Hans & Maria Weber',
    location: 'Munich, Germany',
    quote: 'The Raja Ampat diving expedition was life-changing. Bali Lux Vacances organized every detail perfectly.',
    trip: 'Diving Expedition, Raja Ampat',
    rating: 5
  },
  {
    id: 3,
    name: 'James & Victoria Ashworth',
    location: 'London, UK',
    quote: 'A remarkable family journey through Java and Bali. The children were enchanted, and we were pampered.',
    trip: 'Family Journey, Java & Bali',
    rating: 5
  },
  {
    id: 4,
    name: 'Alexei & Natasha Volkov',
    location: 'Moscow, Russia',
    quote: 'The private yacht cruise through Komodo was absolutely breathtaking. First-class service throughout.',
    trip: 'Yacht Charter, Komodo',
    rating: 5
  }
];

export const companyInfo = {
  name: 'Bali Lux Vacances',
  tagline: 'Luxury Travel Indonesia',
  email: 'lux@balivacances.com',
  phone: '+62-361-412981',
  address: 'Jl Himalaya I A no. 5 Denpasar Utara 80118 Bali Indonesia',
  socialMedia: {
    instagram: '@balivacances',
    facebook: 'BaliVacancesLuxury',
    linkedin: 'bali-vacances'
  },
  about: 'Bali Lux Vacances is a premier luxury travel specialist dedicated exclusively to Indonesia. With deep local expertise and an unwavering commitment to excellence, we craft bespoke journeys that reveal the archipelago\'s most extraordinary destinations and experiences.'
};

export const budgetRanges = [
  { value: '5000-10000', label: '$5,000 - $10,000' },
  { value: '10000-20000', label: '$10,000 - $20,000' },
  { value: '20000-50000', label: '$20,000 - $50,000' },
  { value: '50000+', label: '$50,000+' }
];
